import { cvToJSON, hexToCV } from '@stacks/transactions';
import supportedUTF8HexToEmoji from '../emoji/supportedUTF8HexToEmoji.json';
import { getMessageSentiment } from '../../services/chime';
import { getNames } from '../../services/stacks';
// import axios from 'axios';
// import { stacksApi } from '../../lib/constants';

async function baseconvertHexToEmojiandEscapes(basecontentRaw) {
    let content = basecontentRaw.replace(/\\n/g, "\n");
    content = content.replace(/\\t/g, "\t");
    content = content.replace(/\\\\/g, "\\");
    content = content.replace(/\\'/g, "'");
    content = content.replace(/\\"/g, "\"");
    content = content.replace(/\\r/g, "\r");
    content = content.replace(/\\b/g, "\b");
    content = content.replace(/\\f/g, "\f");
    content = content.replace(/\\v/g, "\v");
    return content.replace(/\\u\{([0-9a-fA-F]+)\}/g, (_, hexCodePoint) => {
        let hex = hexCodePoint.replace(/^\\u\{|\}$/g, '').toLowerCase();
        return supportedUTF8HexToEmoji[hex.toLowerCase()] || "\\u{" + hexCodePoint + "}";
    });
}

const getFileExtension = (url) => {
    // Find the last dot in the URL
    const lastDotIndex = url.lastIndexOf('.');
    // Extract and return the substring after the last dot
    return lastDotIndex !== -1 ? url.substring(lastDotIndex + 1) : '';
};

export async function setUpThreadData(hex, tx, authUser, profilePrincipal, mutedList, isBase) {
    const data = cvToJSON(hexToCV(hex)).value || {};

    const extras = data?.extras?.value?.value?.arg0?.value?.value;

    let authorStorageUrl = extras

    let publisher = data?.publisher?.value;
    const replyTo = data['reply-to']?.value?.value;
    const content = data?.content?.value;

    const attachmentUri = data['attachment-uri']?.value?.value;
    const thumbNailUri = data['thumbnail-uri']?.value?.value;

    if (isBase && profilePrincipal && publisher !== profilePrincipal) {
        publisher = profilePrincipal;
    }
    const { success, names } = await getNames(publisher);

    // const altOrigin = data['alt-origin']?.value?.value || data['alt-origin']?.value;
    // if (attachmentUri !== null || (thumbNailUri !== null && names[0])) {
    //     try {
    //         if (authorStorageUrl === null) {
    //             const { data } = await axios.get(stacksApi[clientNetwork] + "/v1/names/" + names[0] + "/zonefile");
    //             // console.log('zonefile data', data, names[0]);
    //             const { zonefile } = data;
    //             const profileUrl = new RegExp(/https:\/\/(.*)json/).exec(zonefile)[0];
    //             const profileJson = await axios.get(profileUrl);
    //             authorStorageUrl = profileJson.data[0].decodedToken.payload.claim.apps[altOrigin];
    //         }
    //     } catch (error) {
    //         console.log('Error', error);
    //     }
    // }

    const attachmentFileType = typeof attachmentUri === 'string' ? getFileExtension(attachmentUri) : null;
    const imageType = attachmentFileType ? { "jpeg": true, 'jpg': true, 'png': true, 'gif': true }[attachmentFileType] : false;
    const audioType = attachmentFileType ? { 'mp3': true, 'mpeg': true, 'wav': true, 'wave': true }[attachmentFileType] : false;
    const videoType = attachmentFileType ? { 'mp4': true }[attachmentFileType] : false;

    const chimeStxTotal = data['chime-stx-total']?.value;
    const mineTotal = data['mine-total']?.value;
    const cityName = data['cityName']?.value;

    const event = data?.event?.value;
    const devAddress = data['dev-address']?.value?.value;
    const devStxTotal = data['dev-stx-total']?.value;
    const gaiaAddress = data['gaia-address']?.value?.value;
    const gaiaStxTotal = data['gaia-stx-total']?.value;
    const payDev = data['pay-dev']?.value;
    const payGaia = data['pay-gaia']?.value;

    const sentiment = await getMessageSentiment(tx, authUser || "SP1VFTXPFH4S8T99NHWQBJ8BECKZFQ3YFXRN4NJY8");
    // console.log({ sentiment });
    return {
        contenttx: tx,
        publisher,
        name: success ? names[0] : '',
        contentOrigin: authorStorageUrl, replyTo,

        content: await baseconvertHexToEmojiandEscapes(content),
        attachmentUri: attachmentUri,
        thumbNailUri: thumbNailUri,
        imageType, audioType, videoType,

        liked: sentiment?.liked || false, likes: sentiment?.likes || 0,
        disliked: sentiment?.disliked || false, dislikes: sentiment?.dislikes || 0,
        impressions: sentiment?.impressions || 0,
        replied: sentiment?.replied || 0, replies: sentiment?.replies || 0,

        chimeStxTotal, mineTotal,
        cityName,
        event,
        extras,
        devAddress, payDev, devStxTotal,
        gaiaAddress, payGaia, gaiaStxTotal
    }

}